import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import DevicesView from '@/views/DevicesView.vue'
import FamilyGroupsView from '@/views/FamilyGroupsView.vue'
import LoginView from '@/views/LoginView.vue'
import SystemSoundsView from '@/views/SystemSoundsView.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'root',
    redirect: { name: 'devices' },
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/devices',
    name: 'devices',
    component: DevicesView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/devices/:deviceId',
    name: 'device',
    component: DevicesView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/familygroups',
    name: 'familygroups',
    component: FamilyGroupsView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/familygroup/:familyGroupId',
    name: 'familygroup',
    component: FamilyGroupsView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/system-sounds',
    name: 'system-sounds',
    component: SystemSoundsView,
    meta: {
      requiresAuth: true,
    },
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

export default router
